var _path, _path2, _path3, _path4, _path5, _path6, _path7, _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgMapIcon(props) {
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 85,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.902 53.42h18.961v18.92h-18.96z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9 2.365h3.16c3.491 0 6.321 2.824 6.321 6.307 0 3.483-2.83 6.307-6.32 6.307v2.759c-3.95-1.577-9.48-3.942-9.48-9.066 0-3.483 2.829-6.307 6.32-6.307zm1.58 11.037h1.58a4.742 4.742 0 004.106-2.365 4.721 4.721 0 000-4.73 4.742 4.742 0 00-4.105-2.365H7.9a4.735 4.735 0 00-4.74 4.73c0 2.846 1.944 4.703 6.32 6.685v-1.955z",
    fill: "url(#".concat(_id, ")"),
    fillRule: "nonzero",
    transform: "translate(47.902 53.42)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.876 65.37h18.96v18.92h-18.96z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9 2.365h3.16c3.491 0 6.321 2.824 6.321 6.307 0 3.483-2.83 6.307-6.32 6.307v2.759c-3.95-1.577-9.48-3.942-9.48-9.066 0-3.483 2.829-6.307 6.32-6.307zm1.58 11.037h1.58a4.742 4.742 0 004.106-2.365 4.721 4.721 0 000-4.73 4.742 4.742 0 00-4.105-2.365H7.9a4.735 4.735 0 00-4.74 4.73c0 2.846 1.944 4.703 6.32 6.685v-1.955z",
    fill: "url(#".concat(_id2, ")"),
    fillRule: "nonzero",
    transform: "translate(60.876 65.37)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.819 50.432H69.857v18.92H88.82z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9 2.365h3.16c3.491 0 6.321 2.824 6.321 6.307 0 3.483-2.83 6.307-6.32 6.307v2.759c-3.95-1.577-9.48-3.942-9.48-9.066 0-3.483 2.829-6.307 6.32-6.307zm1.58 11.037h1.58a4.742 4.742 0 004.106-2.365 4.721 4.721 0 000-4.73 4.742 4.742 0 00-4.105-2.365H7.9a4.735 4.735 0 00-4.74 4.73c0 2.846 1.944 4.703 6.32 6.685v-1.955z",
    fill: "url(#".concat(_id3, ")"),
    transform: "matrix(-1 0 0 1 88.819 50.432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.035 0c.846 0 1.533.694 1.533 1.547v26.3H46.1c.282 0 .51.231.51.516a.513.513 0 01-.51.516H16.478a.513.513 0 01-.51-.516c0-.285.228-.516.51-.516h1.532v-10.83c0-.852.688-1.546 1.532-1.546h2.043c.845 0 1.533.694 1.533 1.547v10.83h2.043V6.703a1.54 1.54 0 011.532-1.547h2.042a1.54 1.54 0 011.532 1.547v21.143h2.043V11.861c0-.853.688-1.547 1.533-1.547h2.043c.844 0 1.532.694 1.532 1.547v15.986h2.043v-26.3A1.54 1.54 0 0140.992 0h2.043zm-21.45 16.502h-2.043a.514.514 0 00-.51.516v10.83h3.064v-10.83a.514.514 0 00-.51-.516zm7.15-10.314h-2.042a.514.514 0 00-.511.516v21.143h3.064V6.704a.513.513 0 00-.51-.516zm7.15 5.157h-2.042a.514.514 0 00-.511.516v15.986h3.064V11.861a.514.514 0 00-.51-.516zm7.15-10.314h-2.043a.514.514 0 00-.51.516v26.3h3.064v-26.3a.514.514 0 00-.51-.516zM7.485 7.47c.413 0 .748.333.748.746v5.975h5.988c.413 0 .748.334.748.747 0 4.118-3.357 7.469-7.484 7.469S0 19.056 0 14.937C0 10.82 3.358 7.47 7.485 7.47zm-.749 1.54c-2.95.369-5.24 2.887-5.24 5.928 0 3.295 2.687 5.975 5.989 5.975a5.993 5.993 0 005.941-5.228H7.485a.747.747 0 01-.749-.747V9.01zm3.743-4.528c4.127 0 7.484 3.35 7.484 7.469a.747.747 0 01-.748.747h-6.736a.747.747 0 01-.749-.747V5.228c0-.413.335-.747.749-.747zm.748 1.54v5.182h5.193a5.994 5.994 0 00-5.193-5.181z",
    transform: "translate(173.645 39.478)",
    fill: "url(#".concat(_id4, ")")
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.53 0a58.33 58.33 0 01-1.466 10.199c-5.399 23.03-48.372 55.495-2.682 67.308 4.413 1.141 9.257.848 13.859.48 6.384-.509 12.583-2.061 18.875-3.092M88.541 50.93c23.347-25.443 60.305-.268 74.953 11.888 4.72 3.916 11.646 2.21 16.82 1.79",
    stroke: "#979797",
    strokeDasharray: "4,4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.775 37.706L6.752 44.308.164 21.334l23.023-6.602z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.358 29.266c.546.056.624.35.157.669L8.952 41.275c-.46.314-.831.114-.831-.423l-.007-19.77c-.001-.548.304-.66.669-.264l6.872 7.47 9.703.978zm-4.636 1.536l-6.025-.608-4.586-4.986.005 12.855 10.607-7.26z",
    fill: "#707175",
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.722 30.802l-6.025-.608-4.586-4.986.005 12.855 10.607-7.26z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".377%",
    x2: "50%",
    y2: "100%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C868",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BD00",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "9.833%",
    x2: "22.6%",
    y2: "85.155%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "33.71%",
    x2: "22.6%",
    y2: "64.257%",
    id: _id4
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12E3FA",
    offset: "0%"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4277FF",
    offset: "100%"
  })))));
}
export default SvgMapIcon;